import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import { useAuth } from './OlAuthContext';

/**
 * OIDC redirect landing route (redirect_uri = /auth/callback). react-oidc-context performs the
 * PKCE code exchange on load; this screen shows progress and forwards once the session resolves.
 */
export function Callback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.status === 'authenticated') {
      navigate('/flows', { replace: true });
    }
  }, [auth.status, navigate]);

  const wrap = (children: React.ReactNode) => (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      {children}
    </div>
  );

  if (auth.status === 'error') {
    return wrap(
      <Result
        status="error"
        title="Could not complete sign-in"
        subTitle={auth.error}
        extra={
          <Button type="primary" onClick={() => navigate('/', { replace: true })}>
            Back to start
          </Button>
        }
      />,
    );
  }

  return wrap(
    <>
      <Spin size="large" />
      <div style={{ color: 'var(--ol-text-tertiary)' }}>Completing sign-in…</div>
    </>,
  );
}
